import ApiService from 'config/apiServiceApiGateway'
import { buildQueryParams } from 'utils/helpers/queryParams'
import type {
  ReplenishmentTaskV3ActivityType,
  ReplenishmentV3TaskAssignStaffPayloadType,
  ReplenishmentTaskV3Type,
  ReplenishmentV3QueryType,
  ReplenishmentTaskV3ItemType,
  ReplenishmentV3ItemsQueryType,
} from '../@types/ReplenishmentV3'

export type GetReplenishmentTaskV3DetailResponseType = {
  replenishment_task: ReplenishmentTaskV3Type
  replenishment_task_activities: ReplenishmentTaskV3ActivityType[]
}

export const getReplenishmentTaskV3 = (params: ReplenishmentV3QueryType) =>
  ApiService.Get<ReplenishmentTaskV3Type[]>({
    url: '/wims/internal/v1/replenishments/tasks',
    params,
    config: {
      paramsSerializer: {
        serialize: (p) => buildQueryParams(p).toString(),
      },
    },
  })

export const putCancelReplenishmentTask = (id: number) =>
  ApiService.Put<{ message: string }, true>({
    url: `/wims/internal/v1/replenishments/tasks/:id/cancel`,
    urlParams: { id },
  })

export const putAssignReplenishmentStaff = (
  replenishmentTaskId: number,
  data: ReplenishmentV3TaskAssignStaffPayloadType,
) =>
  ApiService.Put<{ message: string }, true>({
    url: `/wims/internal/v1/replenishments/tasks/${replenishmentTaskId}/staff`,
    data,
  })

export const getReplenishmentTaskV3Detail = (id: number) =>
  ApiService.Get<GetReplenishmentTaskV3DetailResponseType>({
    url: '/wims/internal/v1/replenishments/tasks/:id',
    urlParams: { id },
  })

export const getReplenishmentTaskV3Items = (id: number, params: ReplenishmentV3ItemsQueryType) =>
  ApiService.Get<ReplenishmentTaskV3ItemType[]>({
    url: '/wims/internal/v1/replenishments/tasks/:id/items',
    urlParams: { id },
    params,
  })
